<template>
  <div ref="plotlyDiv" class="plotly-div"></div>
</template>

<script>
import Plotly from "plotly.js-dist-min";

export default {
  name: "PlotCustom",
  props: {
    data: {
      type: Array,
      required: true,
    },
    layout: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      default: () => ({ responsive: true }),
    },
  },
  data() {
    return {
      plotlyDiv: null,
      initialized: false, // Flag to check if the chart has been initialized
    };
  },
  watch: {
    data: {
      handler(newData) {
        if (this.initialized) {
          this.updateChart(newData);
        } else {
          this.createChart();
          this.initialized = true;
        }
      },
      deep: true,
    },
    layout: {
      handler(newLayout) {
        if (this.initialized) {
          Plotly.relayout(this.plotlyDiv, newLayout);
        }
      },
      deep: true,
    },
    // Removed the 'config' watcher as 'Plotly.reconfig' does not exist
  },
  mounted() {
    this.plotlyDiv = this.$refs.plotlyDiv;
    this.createChart();
    this.initialized = true;
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    // Updated for Vue 3
    if (this.plotlyDiv) {
      Plotly.purge(this.plotlyDiv);
    }
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    createChart() {
      if (this.plotlyDiv && this.data && this.data.length > 0) {
        Plotly.newPlot(this.plotlyDiv, this.data, this.layout, this.config);
      }
    },
    updateChart(newData) {
      if (this.plotlyDiv && newData && newData.length > 0) {
        // Assuming only one trace; update x and y of the first trace
        Plotly.restyle(
          this.plotlyDiv,
          {
            x: [newData[0].x],
            y: [newData[0].y],
          },
          [0]
        );
      }
    },
    handleResize() {
      if (
        this.plotlyDiv &&
        document.body.contains(this.plotlyDiv) &&
        this.isElementVisible(this.plotlyDiv)
      ) {
        Plotly.Plots.resize(this.plotlyDiv);
      }
    },
    isElementVisible(el) {
      return el.offsetParent !== null;
    },
  },
};
</script>

<style scoped>
.plotly-div {
  width: 100%;
  height: 100%;
}
</style>
